import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '../../components/dropdown/Dropdown';
import { FormsHomeFilterTitle } from './FormsHomeFilterTitle';
import { FilterProps } from './types/FormTypes';

export const FormsHomeFilters = React.memo(
    (props: { filterProps: FilterProps }) => {
        const { t } = useTranslation();

        try {
            const {
                filterProps: {
                    categoryFilterOptions,
                    categoryFilterSelected,
                    handleOnCategoryFilterSelect,
                    departmentFilterOptions,
                    departmentFilterSelected,
                    handleOnDepartmentFilterSelect,
                    handleOnResetFilterSelect,
                },
                filterProps,
            } = props;

            return (
                <>
                    <div className={styles.formsFilterContainer}>
                        <div className={styles.formsFilterSubContainer}>
                            <div
                                className={
                                    styles.formsFilterDropdownTitleContainer
                                }
                            >
                                {t('FormsBrowser.CategoryFilter')}
                            </div>
                            <Dropdown
                                placeholder={'...'}
                                options={categoryFilterOptions}
                                onChange={handleOnCategoryFilterSelect}
                                value={categoryFilterSelected}
                                search={true}
                                aria-label={t('FormsBrowser.CategoryFilter')}
                            />
                        </div>
                        <div className={styles.formsFilterSubContainer}>
                            <div
                                className={
                                    styles.formsFilterDropdownTitleContainer
                                }
                            >
                                {t('FormsBrowser.DepartmentFilter')}
                            </div>
                            <Dropdown
                                placeholder={'...'}
                                options={departmentFilterOptions}
                                onChange={handleOnDepartmentFilterSelect}
                                value={departmentFilterSelected}
                                search={true}
                                aria-label={t('FormsBrowser.DepartmentFilter')}
                            />
                        </div>
                    </div>
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.button}
                            onClick={() => handleOnResetFilterSelect()}
                        >
                            {t('FormsBrowser.ResetFilter')}
                        </button>
                    </div>
                    <FormsHomeFilterTitle filterProps={filterProps} />
                </>
            );
        } catch {
            return null;
        }
    },
);
